export default "__VITE_ASSET__DvGcGvuU__"